<div class="page">
  <h3>Список запросов востановления пароля</h3>
  <ng2-smart-table [settings]="settings" [source]="recoverList"></ng2-smart-table>
</div>
